import { CssBaseline, ThemeProvider } from "@mui/material";
import { createTheme } from "@mui/material/styles";
import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { themeSettings } from "theme";
import 'mdb-react-ui-kit/dist/css/mdb.min.css';
import "@fortawesome/fontawesome-free/css/all.min.css";
import Layout from "scenes/layout";
import Login from "scenes/login";
import Registro from "scenes/register";
import ResetPass from "scenes/resetPass";
import CreatePass from "scenes/createPass";
import Dashboard from "scenes/dashboard";
import DashboardSaludEmergencia from "scenes/dashboardSaludEmergencia";
import DashboardOperativo from "scenes/dashboardOperativo";
import ReporteSaludEmergencia, {
  ReporteSaludEmergenciaRouteGuard,
} from "scenes/reporteSaludEmergencia";
import Proyectos from "scenes/proyectos";
import UsuariosProyectos, {
  UsuariosProyectosRouteGuard,
} from "scenes/usuariosProyectos";
import MealIncidencias, {
  MealIncidentsRouteGuard,
} from "scenes/mealIncidencias";
import Beneficiarios from "scenes/beneficiarios";
import Voluntariado from "scenes/voluntariado";
import Logistica from "scenes/logistica";
import Suministros from "scenes/suministros";
import GestionHumana from "scenes/gestionhumana";
import Admin from "scenes/admin";
import Upload from "scenes/cargar-datos";
//import Actividades from "scenes/proyectos/actividades";
import CrearProyecto from "scenes/proyectos/crearProyecto";
import EditarProyecto from "scenes/proyectos/editarProyecto";
import AdminEquipos from "scenes/proyectos/adminEquipos";
import AgregarMiembros from "scenes/proyectos/agregarMiembros";
import GestionProyectos from "scenes/proyectos/gestionProyectos";
import Estadisticas from "scenes/proyectos/estadisticas";
import CrearActividad from "scenes/voluntariado/crearActividad";
import EditarActividad from "scenes/voluntariado/editarActividad";
import ControlAsistenciaVoluntariado from "scenes/voluntariado/controlAsistencia";
import AceptarUsuarios from "scenes/admin/aceptarUsuarios";
import Logros from "scenes/voluntariado/logros";
import Asistencia from "scenes/gestionhumana/asistencia";
import ReporteAsistencia from "scenes/gestionhumana/asistreporte";
import ListadoAsistencia from "scenes/gestionhumana/asistlista";
import EasterEgg from "scenes/easterEgg";
import SolicitudSum from "scenes/suministros/solicitudSum";
import ListaConvocatorias from "scenes/suministros/convoList";
import ReporteSuministros from "scenes/suministros/reportSum";
import ProcesarSolicitud from "scenes/suministros/procSolicitud";
import EditarSolicitud from "scenes/suministros/editarSolicitud";
import FinalizarSolicitud from "scenes/suministros/finSolicitud";
import Retroalimentacion from "scenes/gestionhumana/retroalimentacion";
import RetroConvocatorias from "scenes/gestionhumana/retroConvos";
import CrearRetro from "scenes/gestionhumana/crearRetro";
import ReporteSuministrosEntrada from "scenes/suministros/reportSumEnt";
import InfoPage from "scenes/register/info";
import PerfilVoluntario from "scenes/voluntariado/perfilVoluntario";
import Transcripcion from "scenes/transcripcion";
import ListaTranscripcion from "scenes/transcripcion/transLista";
import SaludForm from "scenes/transcripcion/saludForm";
import SaludFormV2 from "scenes/transcripcion/saludFormV2";
import NutriForm from "scenes/transcripcion/nutriForm";
import EditarSalud from "scenes/transcripcion/editarSalud";
import EditarSaludV2 from "scenes/transcripcion/editarSaludV2";
import EditarNutri from "scenes/transcripcion/editarNutri";
import ErrorPage from "scenes/login/error";
import DesktopNotification from "scenes/login/notiTest";
import EstadisticasGenerales from "scenes/proyectos/stats";
import Postulacion from "scenes/postulacion";
import Postulaciones from "scenes/gestionhumana/postulaciones";
import GeneradorFichas from "scenes/dashboard/genFichas";
import CalculadoraPZ from "scenes/dashboard/calcPuntajeZ";
import InfoReset from "scenes/resetPass/infoReset";
import Consolidado from "scenes/transcripcion/consolidado";
import PdfConsolidado from "scenes/transcripcion/pdfConsolidado";
import Maps from "scenes/logistica/maps";
import ResultadosBusqueda from "scenes/beneficiarios/resultadosBusqueda";
import ConsolidadoAsistencia from "scenes/gestionhumana/consolidadoAsistencia";
import Promotores from "scenes/voluntariado/promotores";
import AntiConForm from "scenes/transcripcion/antiConForm";
import CapForm from "scenes/transcripcion/capForm";
import EditarAntiConForm from "scenes/transcripcion/editarAntiConForm";
import EditarCapForm from "scenes/transcripcion/editarCapForm";
import QuestionForm from "scenes/gestionhumana/crearPreguntas";
import QuizForm from "scenes/gestionhumana/quizForm";
import PoolsLista from "scenes/gestionhumana/poolsLista";
import QuestionLista from "scenes/gestionhumana/questionLista";
import CrearTest from "scenes/gestionhumana/crearTest";
import TestDashboard from "scenes/gestionhumana/testDashboard";
import TestUserDashboard from "scenes/dashboard/testUserDashboard";
import { Certificate } from "scenes/dashboard/certificate";
import GestionBoletin from "scenes/gestionhumana/gestionBoletin";
import NutriSaludForm from "./scenes/transcripcion/nutriSaludForm";
import AntiConFormV2 from "scenes/formulariosV2/anticonceptivos/AntiConFormV2";
import NutriSaludFormV2 from "scenes/formulariosV2/nutrisalud/NutriSaludFormV2";
import EditarNutriSaludForm from "scenes/transcripcion/editarNutriSaludForm";
import RevisionRapidaSalud, {
  RevisionRapidaSaludRouteGuard,
} from "scenes/revisionRapidaSalud";
import RegistrosRevisionRapidaSalud from "scenes/revisionRapidaSalud/RegistrosPlaceholder";
import RegistroDetalleRevisionRapidaSalud from "scenes/revisionRapidaSalud/RegistroDetallePlaceholder";
import {
  canAccessSaludV2Route,
  getStoredUser,
} from "scenes/transcripcion/saludClinicaV2Utils";

const SaludV2RouteGuard = ({ mode, children }) =>
  canAccessSaludV2Route({ user: getStoredUser(), mode }) ? (
    children
  ) : (
    <Navigate to="/accessDenied" replace />
  );

const FormulariosV2RouteGuard = ({ children }) =>
  new Set([1, 2, 6, 8, 9, 10, 11]).has(Number(getStoredUser()?.rol)) ? (
    children
  ) : (
    <Navigate to="/accessDenied" replace />
  );

function App() {
 const mode = useSelector((state) => state.global.mode);
 const theme = useMemo(() => createTheme(themeSettings(mode)), [mode]);

 //Protección de rutas
 const ProtectedRoute = ({ redirectPath = '/accessDenied' }) => {
    const storedToken = localStorage.getItem('token');
    if (storedToken !== null) {
      const parsedToken = JSON.parse(storedToken);
      const SOCIO_ALLOWED_PATHS = new Set([
        "/saludemergencia",
        "/reportes-salud-emergencia",
      ]);

      if (String(parsedToken?.rol) === "13" && !SOCIO_ALLOWED_PATHS.has(window.location.pathname)) {
        return <Navigate to="/saludemergencia" replace />;
      }

      return <Layout />;
    } else {
      return <Navigate to={redirectPath} replace />;
    }
  };

  return (
    <div className="app">
      <BrowserRouter>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/registro" element={<Registro />} />
            <Route path="/resetPass" element={<ResetPass />} />
            <Route path="/createPass" element={<CreatePass />} />
            <Route path="/postulacion" element={<Postulacion />} />
            <Route path="/info" element={<InfoPage />} />
            <Route path="/infoReset" element={<InfoReset />} />
            <Route path="/secret" element={<EasterEgg />} />
            <Route path="/accessDenied" element={<ErrorPage />} />
            <Route path="/notiTest" element={<DesktopNotification />} />
            <Route path="/pdfConsolidado" element={<PdfConsolidado />} />
              <Route element={<ProtectedRoute replace />}>
                {/*<Route path="/" element={<Navigate to="/inicio" replace />} />*/}
                <Route path="/inicio" element={<Dashboard />} />
                <Route path="/saludemergencia" element={<DashboardSaludEmergencia />} />
                <Route path="/dashboard-operativo" element={<DashboardOperativo />} />
                <Route
                  path="/reportes-salud-emergencia"
                  element={
                    <ReporteSaludEmergenciaRouteGuard>
                      <ReporteSaludEmergencia />
                    </ReporteSaludEmergenciaRouteGuard>
                  }
                />
                <Route path="/generadorFichas" element={<GeneradorFichas />} />
                <Route path="/calculadoraPuntajeZ" element={<CalculadoraPZ />} />
                <Route path="/proyectos" element={<Proyectos />} />
                <Route
                  path="/usuarios-proyectos"
                  element={
                    <UsuariosProyectosRouteGuard>
                      <UsuariosProyectos />
                    </UsuariosProyectosRouteGuard>
                  }
                />
                <Route
                  path="/meal/incidencias"
                  element={
                    <MealIncidentsRouteGuard>
                      <MealIncidencias />
                    </MealIncidentsRouteGuard>
                  }
                />
                <Route path="/beneficiarios" element={<Beneficiarios />} />
                <Route path="/gestionhumana" element={<GestionHumana />} />
                <Route path="/voluntariado" element={<Voluntariado />} />
                <Route path="/voluntariado/asistencia" element={<ControlAsistenciaVoluntariado />} />
                <Route path="/logistica" element={<Logistica />} />
                <Route path="/map" element={<Maps />} />
                <Route path="/suministros" element={<Suministros />} />
                <Route path="/editarSolicitudSum" element={<EditarSolicitud />} />
                <Route path="/procesarSolicitud" element={<ProcesarSolicitud />} />
                <Route path="/finalizarSolicitud" element={<FinalizarSolicitud />} />
                <Route path="/solicitudSuministros" element={<SolicitudSum />} />
                <Route path="/listaConvocatorias" element={<ListaConvocatorias />} />
                <Route path="/reporteSuministros" element={<ReporteSuministros />} />
                <Route path="/reporteSumEntrada" element={<ReporteSuministrosEntrada />} />
                <Route path="/admin" element={<Admin />} />
                <Route path="/crearProyecto" element={<CrearProyecto />} />
                <Route path="/editarProyecto" element={<EditarProyecto />} />
                <Route path="/adminEquipos" element={<AdminEquipos />} />
                <Route path="/agregarMiembros" element={<AgregarMiembros />} />
                <Route path="/gestionProyectos" element={<GestionProyectos />} />
                <Route path="/estadisticas" element={<Estadisticas />} />
                <Route path="/estadisticasGenerales" element={<EstadisticasGenerales />} />
                {/*<Route path="/actividades" element={<Actividades />} />*/}
                <Route path="/crearConvocatoria" element={<CrearActividad />} />
                <Route path="/editarConvocatoria" element={<EditarActividad />} />
                <Route path="/promotores" element={<Promotores />} />
                <Route path="/perfil" element={<PerfilVoluntario />} />
                <Route path="/logros" element={<Logros />} />
                <Route path="/aceptarUsuarios" element={<AceptarUsuarios />} />
                <Route path="/asistencia" element={<Asistencia />} />
                <Route path="/asistreporte" element={<ReporteAsistencia />} />
                <Route path="/asistlista" element={<ListadoAsistencia />} />
                <Route path="/asistConsolidado" element={<ConsolidadoAsistencia />} />
                <Route path="/retroalimentacion" element={<Retroalimentacion />} />
                <Route path="/retroConvocatorias" element={<RetroConvocatorias />} />
                <Route path="/postulaciones" element={<Postulaciones />} />
                <Route path="/transcripcion" element={<Transcripcion />} />
                <Route path="/listaTranscripcion" element={<ListaTranscripcion />} />
                <Route
                  path="/revision-rapida-salud/:convocatoriaId"
                  element={
                    <RevisionRapidaSaludRouteGuard>
                      <RevisionRapidaSalud />
                    </RevisionRapidaSaludRouteGuard>
                  }
                />
                <Route
                  path="/revision-rapida-salud/:convocatoriaId/registros"
                  element={
                    <RevisionRapidaSaludRouteGuard>
                      <RegistrosRevisionRapidaSalud />
                    </RevisionRapidaSaludRouteGuard>
                  }
                />
                <Route
                  path="/revision-rapida-salud/:convocatoriaId/registros/:registroId"
                  element={
                    <RevisionRapidaSaludRouteGuard>
                      <RegistroDetalleRevisionRapidaSalud />
                    </RevisionRapidaSaludRouteGuard>
                  }
                />
                <Route path="/saludFormulario" element={<SaludForm />} />
                <Route
                  path="/saludFormularioV2"
                  element={
                    <SaludV2RouteGuard mode="create">
                      <SaludFormV2 />
                    </SaludV2RouteGuard>
                  }
                />
                <Route path="/nutriFormulario" element={<NutriForm />} />
                <Route path="/nutriSaludFormulario" element={<NutriSaludForm />} />
                <Route path="/formularios-v2/nutrisalud" element={<FormulariosV2RouteGuard><NutriSaludFormV2 /></FormulariosV2RouteGuard>} />
                <Route path="/formularios-v2/anticonceptivos" element={<FormulariosV2RouteGuard><AntiConFormV2 /></FormulariosV2RouteGuard>} />
                <Route path="/editarNutriSaludForm" element={<EditarNutriSaludForm />} />
                <Route path="/antiConFormulario" element={<AntiConForm />} />
                <Route path="/editarAntiConFormulario" element={<EditarAntiConForm />} />
                <Route path="/capFormulario" element={<CapForm />} />
                <Route path="/editarCapFormulario" element={<EditarCapForm />} />
                <Route path="/editarSalud" element={<EditarSalud />} />
                <Route
                  path="/editarSaludV2"
                  element={
                    <SaludV2RouteGuard mode="edit">
                      <EditarSaludV2 />
                    </SaludV2RouteGuard>
                  }
                />
                <Route path="/editarNutri" element={<EditarNutri />} />
                <Route path="/baseDatos" element={<Consolidado />} />
                <Route path="/crearRetroalimentacion" element={<CrearRetro />} />
                <Route path="/cargar-datos" element={<Upload />} />
                <Route path="/resultadosBusqueda" element={<ResultadosBusqueda />} />
                <Route path="/crearPregunta" element={<QuestionForm />} />
                <Route path="/quiz" element={<QuizForm />} />
                <Route path="/poolLista" element={<PoolsLista />} />
                <Route path="/questionLista" element={<QuestionLista />} />
                <Route path="/crearTest" element={<CrearTest />} />
                <Route path="/testDashboard" element={<TestDashboard />} />
                <Route path="/testUserDashboard" element={<TestUserDashboard/>} />
                <Route path="/certificado" element={<Certificate/>} />
                <Route path="/certificado" element={<Certificate/>} />
                <Route path="/gestionBoletin" element={<GestionBoletin />} />
              </Route>
          </Routes>
        </ThemeProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
